module.exports = __webpack_public_path__ + "static/media/backspace.357d6c15.svg";